var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircleOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_566_6663)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9636 3.51258C11.1727 3.51258 8.49603 4.62128 6.52253 6.59479C4.54902 8.5683 3.44031 11.2449 3.44031 14.0359C3.44031 16.8269 4.54902 19.5035 6.52253 21.477C8.49603 23.4505 11.1727 24.5592 13.9636 24.5592C16.7546 24.5592 19.4313 23.4505 21.4048 21.477C23.3783 19.5035 24.487 16.8269 24.487 14.0359C24.487 11.2449 23.3783 8.5683 21.4048 6.59479C19.4313 4.62128 16.7546 3.51258 13.9636 3.51258ZM5.73057 5.80283C7.91411 3.61928 10.8756 2.39258 13.9636 2.39258C17.0516 2.39258 20.0132 3.61928 22.1967 5.80283C24.3803 7.98638 25.607 10.9479 25.607 14.0359C25.607 17.1239 24.3803 20.0854 22.1967 22.269C20.0132 24.4525 17.0516 25.6792 13.9636 25.6792C10.8756 25.6792 7.91411 24.4525 5.73057 22.269C3.54702 20.0854 2.32031 17.1239 2.32031 14.0359C2.32031 10.9479 3.54702 7.98638 5.73057 5.80283Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2579 10.25C19.4766 10.4687 19.4766 10.8232 19.2579 11.0419L12.1638 18.136L8.79097 14.7632C8.57228 14.5445 8.57228 14.1899 8.79097 13.9712C9.00967 13.7525 9.36424 13.7525 9.58293 13.9712L12.1638 16.5521L18.466 10.25C18.6846 10.0313 19.0392 10.0313 19.2579 10.25Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_566_6663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircleOutlineIcon);
export default __webpack_public_path__ + "static/media/tick-circle-outline-icon.2cddadf74ba71b3e9e9531060ce45636.svg";
export { ForwardRef as ReactComponent };